import { render, staticRenderFns } from "./action-groups-table.vue?vue&type=template&id=e67ff71c"
import script from "./action-groups-table.ts?vue&type=script&lang=js&external"
export * from "./action-groups-table.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports